"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const debounce_1 = require("@common/tsutils/debounce");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const FarmListController_1 = __importDefault(require("./modules/controllers/FarmListController"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const geom_1 = require("ol/geom");
const Utils_1 = require("../Map/Utils");
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const proj_1 = require("ol/proj");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const FieldsTable_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/FieldsTable.vue"));
const PreQuoteModal_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/PreQuoteModal.vue"));
const LockTag_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/LockTag.vue"));
const moment_1 = __importDefault(require("moment"));
let FarmCRUDView = class FarmCRUDView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAP_ID = 'preview-map-container';
        this.MAP_CONTROLLER = new Controller_1.default();
        this.CONTROLLER = FarmListController_1.default.getInstance();
        this.hasExpandPanelMap = false;
        this.timesAvailable = [];
        this.farmName = '';
        this.oldFarmName = '';
        this.editingFarmName = false;
        this.time = null;
        this.originalFarm = null;
        this.savingFarmName = false;
        this.savedFarmNameFeedback = '';
        this.savedFarmNameFeedbackMessage = [];
        this.removingField = false;
        this.removedFieldFeedback = '';
        this.removedFieldFeedbackMessage = [];
        this.updatingField = false;
        this.updatedFieldFeedback = '';
        this.updatedFieldColumn = '';
        this.updatedFieldRow = -1;
        this.updatedFieldFeedbackMessage = [];
        this.isPreQuoteModalActive = false;
    }
    get configurationFields() {
        return this.CONTROLLER.activeFarm.configurationFields;
    }
    get isActiveFarm() {
        return this.CONTROLLER.activeFarm.active;
    }
    initializeFieldUpdate() {
        this.updatingField = false;
        /* this.updatedFieldFeedback = ''
        this.updatedFieldFeedbackMessage = []
        this.updatedFieldColumn = ''
        this.updatedFieldRow = -1 */
    }
    initializeFieldRemoval() {
        this.removingField = false;
        this.removedFieldFeedback = '';
        this.removedFieldFeedbackMessage = [];
    }
    closeToast() {
        this.initializeFieldUpdate();
    }
    addNewField() {
        this.CONTROLLER.addNewField();
    }
    requestQuote() {
        this.deployPreQuoteModal();
    }
    deployPreQuoteModal() {
        this.isPreQuoteModalActive = true;
    }
    dismissPreQuoteModal() {
        this.isPreQuoteModalActive = false;
    }
    get metadataLibrary() {
        return this.CONTROLLER.library;
    }
    adjustFarmNameInput(name) {
        // @ts-ignore
        const container = this.$refs.inputName.$el;
        if (name.length > 0) {
            if (container && container instanceof HTMLElement) {
                const input = container.querySelector('input');
                input.style.width = name.length + 'ch';
                if (name.length < 10) {
                    input.style.width = '10ch';
                }
            }
        }
        else {
            const input = container.querySelector('input');
            input.style.width = '10ch';
        }
    }
    setFarmAsEditing(s) {
        this.farmName = s;
        this.editingFarmName = true;
    }
    undoFarmEdition() {
        this.farmName = this.oldFarmName;
        this.undoEdition();
    }
    async requestFarmName(name) {
        this.adjustFarmNameInput(name);
        await this.updateFarmName(name);
    }
    async updateFarmName(name) {
        try {
            if (name.length > 0) {
                if (name !== this.CONTROLLER.activeFarm.name) {
                    this.savedFarmNameFeedback = '';
                    this.savedFarmNameFeedbackMessage = [];
                    this.savingFarmName = true;
                    const resp = await this.CONTROLLER.editFarmName(name, this.CONTROLLER.activeFarm);
                    if (resp.status === 200) {
                        this.savedFarmNameFeedback = 'ok';
                        this.savedFarmNameFeedbackMessage.push('Name Updated!');
                        this.oldFarmName = name;
                    }
                    else {
                        this.savedFarmNameFeedback = 'error';
                        this.savedFarmNameFeedbackMessage = [...resp.messages];
                    }
                }
            }
            else {
                this.requestFarmName(this.CONTROLLER.activeFarm.name);
                this.farmName = this.CONTROLLER.activeFarm.name;
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.savingFarmName = false;
            this.undoEdition();
        }
    }
    undoEdition() {
        this.editingFarmName = false;
        /* this.savedFarmNameFeedback = ''
        this.savedFarmNameFeedbackMessage = [] */
    }
    setFieldAsEditing(f, c) {
        this.CONTROLLER.activeFarm.setFieldAsEditing(f);
        if (c === 'crop') {
            this.drawFarmInMap(this.CONTROLLER.activeFarm);
        }
    }
    undoFieldEdition(f) {
        this.CONTROLLER.activeFarm.undoFieldEdition(f);
        this.MAP_CONTROLLER.desactivarEdicionPoligonos();
        this.drawFarmInMap(this.CONTROLLER.activeFarm);
    }
    async updateField(f, c) {
        try {
            this.updatedFieldFeedback = '';
            this.updatedFieldFeedbackMessage = [];
            this.updatedFieldColumn = c;
            this.updatedFieldRow = f.id;
            this.updatingField = true;
            const GisFieldToUpdate = this.CONTROLLER.activeFarm.parseConfigurationFieldIntoGisField(f);
            const resp = await this.CONTROLLER.updateField(GisFieldToUpdate);
            if (resp.status === 200) {
                this.updatedFieldFeedback = 'ok';
                this.updatedFieldFeedbackMessage.push('Field Updated!');
                this.drawFarmInMap(this.CONTROLLER.activeFarm);
                this.MAP_CONTROLLER.desactivarEdicionPoligonos();
            }
            else {
                this.updatedFieldFeedback = 'error';
                this.updatedFieldFeedbackMessage = [...resp.messages];
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.initializeFieldUpdate();
            /*             if(c !== 'metadata') {
            
                        } */
        }
    }
    updateTimeSelected(model) {
        this.CONTROLLER.setActiveFarmTime(model.value);
        this.originalFarm = JSON.parse(JSON.stringify(this.CONTROLLER.activeFarm));
        this.drawFarmInMap(this.CONTROLLER.activeFarm);
        this.time = this.timeOptions.find((t) => t.value === model.value);
    }
    get hasChanges() {
        return this.originalFarm.gis_fields !== this.CONTROLLER.activeFarm.gis_fields;
    }
    get timeOptions() {
        return this.timesAvailable.map((s) => {
            return {
                label: (0, moment_1.default)(s).format('DDMMMYYYY'),
                value: s,
                locked: this.CONTROLLER.isTimeLocked(s)
            };
        });
    }
    expandPanelMap() {
        this.hasExpandPanelMap = !this.hasExpandPanelMap;
    }
    async confirmFieldRemoval(f) {
        try {
            this.removingField = true;
            this.removedFieldFeedback = '';
            this.removedFieldFeedbackMessage = [];
            const GisFieldToRemove = this.CONTROLLER.activeFarm.parseConfigurationFieldIntoGisField(f);
            const resp = await this.CONTROLLER.removeField(GisFieldToRemove);
            if (resp.status === 200) {
                this.removedFieldFeedback = 'ok';
                this.removedFieldFeedbackMessage.push('Field Removed!');
                this.drawFarmInMap(this.CONTROLLER.activeFarm);
            }
            else {
                this.removedFieldFeedback = 'error';
                this.removedFieldFeedbackMessage = [...resp.messages];
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.removingField = false;
        }
    }
    get mapInstance() {
        return this.MAP_CONTROLLER.map;
    }
    get fieldModify() {
        return this.MAP_CONTROLLER.currentFieldModify;
    }
    get currentFieldModifyWKT() {
        return this.MAP_CONTROLLER.currentFieldModifyWKT;
    }
    async updateFields() {
        const field = this.CONTROLLER.activeFarm.fields.find((gf) => `${gf.name}${gf.id}` === this.fieldModify.get('name'));
        if (field) {
            field.geodata = this.MAP_CONTROLLER.currentFieldModifyWKT.toString();
            field.updateSize();
            this.setFieldAsEditing(this.CONTROLLER.activeFarm.findConfigurationFieldFromGisField(field));
        }
    }
    drawFieldInMap() {
        /* console.log('draw field') */
    }
    clearMap() {
        /* console.log('clear map')
        removeLayerById('zone-layer', this.MAP_CONTROLLER.map); */
    }
    back() {
        window.location.href = '/farm/list';
    }
    async drawFarmInMap(farm) {
        (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
        const polygons = [];
        farm.fields.forEach((field) => {
            if ((0, Utils_1.getExtension)(field.geodata) >= 1) {
                polygons.push(field.geodata);
                this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                    geoData: field.geodata,
                    fillColor: field.fill,
                    strokeColor: field.stroke,
                    enableHoverInteraction: true,
                    enableSelectInteraction: true,
                    zoneName: `${field.name}${field.id}`,
                    centerZone: false,
                    avg: 0,
                    markers: [],
                    preciseResult: false,
                    modifyInteraction: !farm.locked,
                }), 700, [100, 100, 100, 500]);
            }
        });
        const polygonsWkt = polygons.map(Utils_1.parseWKT);
        const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
        const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
        (0, CenterUtility_1.center)(this.mapInstance, extent, 700, [100, 100, 100, 500]);
    }
    async mounted() {
        // @ts-ignore
        const container = this.$refs.inputName.$el;
        if (container && container instanceof HTMLElement) {
            const input = container.querySelector('input');
            input.focus();
        }
        const url = window.location.pathname;
        const match = url.match(/\/farm\/(\d+)\/edit/);
        const farmId = match ? match[1] : null;
        await this.CONTROLLER.fetchFarmHistory(parseInt(farmId));
        this.CONTROLLER.setActiveFarmFromHistory();
        this.timesAvailable = this.CONTROLLER.historicFarm.times;
        if (this.timesAvailable.length > 0) {
            this.time = this.timeOptions.find((o) => o.value === this.CONTROLLER.activeFarm.date);
        }
        if (this.CONTROLLER.historicFarm.farmHistory.length > 0) {
            this.farmName = this.CONTROLLER.activeFarm.name;
            this.oldFarmName = this.CONTROLLER.activeFarm.name;
        }
        this.MAP_CONTROLLER.create(this.MAP_ID, this.map_config.provider, this.map_config.apikey, '', '', '');
        this.MAP_CONTROLLER.addSelectInteractions();
        this.drawFarmInMap(this.CONTROLLER.activeFarm);
        this.originalFarm = JSON.parse(JSON.stringify(this.CONTROLLER.activeFarm));
        await this.CONTROLLER.fetchLibrary();
        /*         await this.CONTROLLER.changeFarmListPage(1);
                this.CONTROLLER.setInitialFarm(); */
        // this.drawFarmInMap(this.CONTROLLER.activeFarm);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmCRUDView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmCRUDView.prototype, "dataset", void 0);
__decorate([
    (0, debounce_1.Debounce)(400)
], FarmCRUDView.prototype, "updateFarmName", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentFieldModifyWKT')
], FarmCRUDView.prototype, "updateFields", null);
FarmCRUDView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { InputField: bmk_ui_framework_1.InputField, Loader: bmk_ui_framework_1.Loader, Check: lucide_vue_next_1.Check, Select: bmk_ui_framework_1.Select, FieldsTable: FieldsTable_vue_1.default, ArrowLeftCircle: lucide_vue_next_1.ArrowLeftCircle, ArrowRightCircle: lucide_vue_next_1.ArrowRightCircle, MapAttributions: bmk_ui_framework_1.MapAttributions, Button: bmk_ui_framework_1.Button, Plus: lucide_vue_next_1.Plus, Minus: lucide_vue_next_1.Minus, Expand: lucide_vue_next_1.Expand, XRoundedIcon: bmk_ui_framework_1.XRoundedIcon, PreQuoteModal: PreQuoteModal_vue_1.default, SelectField: bmk_ui_framework_1.SelectField, LockTag: LockTag_vue_1.default, MicroFeedback: bmk_ui_framework_1.MicroFeedback, X: lucide_vue_next_1.X }
    })
], FarmCRUDView);
exports.default = FarmCRUDView;
